import { useAppStore } from "@hooks/useAppStore";
import { getAiAssistantIconUri } from "@memorang/helpers/constants";
import { AiFab } from "@memorang/ui/components/AiFab";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { useDevice } from "@memorang/ui/useDevice";
import { usePathname, useRouter } from "expo-router";
import { memo } from "react";
import useAIFeedbackStore from "../hooks/useAIFeedbackStore";
import { useAilaStore } from "../hooks/useAilaStore";
import { useStimulusStore } from "../hooks/useStimulusStore";

type Props = {
	itemId: number;
	shouldRender: boolean;
	shouldShowAiDisclaimer: boolean;
	handleShowAiDisclaimer: () => void;
};

const AiSessionFab = ({
	itemId,
	shouldRender,
	shouldShowAiDisclaimer,
	handleShowAiDisclaimer,
}: Props) => {
	const router = useRouter();
	const pathname = usePathname();
	const theme = useAppTheme();
	const { isDesktopWeb } = useDevice();

	const isAssistantVisible = useAilaStore((state) => state.showDrawer);
	const updateIsAssistantVisible = useAilaStore(
		(state) => state.updateShowDrawer,
	);
	const isAiFeedbackStreaming = useAIFeedbackStore((state) => state.streaming);
	const showStimulusModal = useStimulusStore(
		(state) => state.showStimulusModal,
	);
	const aiAssistantFabIcon = useAppStore(
		(store) => store.app.aiAssistant.fabIcon,
	);
	const aiAssistantFabDarkIcon = useAppStore(
		(store) => store.app.aiAssistant.fabDarkIcon,
	);

	const getAiAssistantFabIcon = () => {
		const defaultIcon = getAiAssistantIconUri(aiAssistant, theme.dark);

		if (aiAssistantFabDarkIcon && aiAssistantFabIcon) {
			return theme.dark ? aiAssistantFabDarkIcon : aiAssistantFabIcon;
		}
		return defaultIcon;
	};
	const aiAssistantAlias = useAppStore((store) => store.app.aiAssistant.alias);

	const aiAssistant = useAppStore((store) => store.app.aiAssistant);
	const aiAssistantIcon = getAiAssistantFabIcon();

	const isAilaRoute = pathname.startsWith("/aila/");
	const isVisible =
		!isAssistantVisible &&
		shouldRender &&
		!isAiFeedbackStreaming &&
		!showStimulusModal &&
		!isAilaRoute;

	if (!isVisible) {
		return null;
	}

	const handlePress = () => {
		if (shouldShowAiDisclaimer) {
			handleShowAiDisclaimer();
			return;
		}

		if (isDesktopWeb) {
			updateIsAssistantVisible(true);
			return;
		}

		router.push(`/aila/${itemId}`);
	};

	return (
		<AiFab
			icon={aiAssistantIcon}
			label={aiAssistantAlias}
			onPress={handlePress}
		/>
	);
};

export default memo(AiSessionFab);
